export enum PaidEventsConfigurationSteps {
  Selection = 'Selection',
  Status = 'Status'
}
